import React from 'react';
import PropTypes from 'prop-types';

/*
 * Hidden file input
 */
function SimpleFileUpload({ children, multiple = false, accept = null, onUpload, disabled = false, className = 'btn btn-xs btn-icon' }) {
  let inputRef = null;
  const handleClick = () => {
    if (disabled) return;
    if (inputRef) inputRef.click();
  };

  return (
    <>
      <input
        type="file"
        style={{ display: 'none' }}
        className="simpleFileUpload"
        ref={e => {
          inputRef = e;
        }}
        multiple={multiple}
        accept={accept}
        // required to allow the control to be used more than once without refresh of entire page
        onClick={e => (e.target.value = '')}
        onChange={e => onUpload(e.target.files)}
      />
      {typeof children === 'function' ? (
        children({ onClick: handleClick })
      ) : (
        <button
          type="button"
          onClick={() => handleClick()}
          disabled={disabled}
          className={className}
        >
          {children}
        </button>
      )}
    </>
  );
}
SimpleFileUpload.propTypes = {
  onUpload: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired, // Render function (with onClick) or node

  multiple: PropTypes.bool, // Upload multiple files
  accept: PropTypes.string, // Filter files https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#accept,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default SimpleFileUpload;
